import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { UserService } from '../../../services/UserService';

export interface Props {
    userId: number;
}

interface State {
    NouveauMotDePass: string;
    ConfirmationMotDePass: string;
}

/**
 * Ce composant permet d'afficher de la liste des média correspondant à ce profil
 */
export class ModifMdpProfileShow extends React.Component {
    props: Props;
    state: State;
    backupProfil: ReqType.UserView;

    constructor(props: Props) {
        super(props);
        this.state = {
            NouveauMotDePass: '',
            ConfirmationMotDePass: '',
        };
    }

    render() {
        return (
            <div className="card card-default">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong> Modification de mot de passe </strong>
                    </h4>
                </div>

                <div className="card-body">
                    <this.DisplayInformation />
                </div>

                <div className="card-footer" >
                    <div className="container-fluid justify-content-end" style={{ display: 'flex' }}>
                        <button
                            className="btn btn-lg btn-outline-danger"
                            onClick={
                                () => {
                                    this.setState(
                                        {
                                            NouveauMotDePass: '',
                                            ConfirmationMotDePass: '',
                                        });
                                }
                            }

                        >
                            Abandonner
                        </button>
                        <LoaderButton
                            className="btn btn-lg"
                            onClick={this.sendServer}
                            confirmation={true}
                            style={{marginLeft: '20px'}}
                            modalTitle="Changement de mot de passe"
                            modalBody="Etes vous certain de vouloir changer le mot de passe de cet utilisateur ?"
                            disabled={
                                this.state.NouveauMotDePass !== this.state.ConfirmationMotDePass ||
                                this.state.NouveauMotDePass.length < 6
                            }
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div>
            </div>
        );
    }

    private DisplayModifMotDePasse() {
        const liClass = 'list-group-item list-group-item-danger';
        return (
            <li className={liClass}>
                <input
                    className="form-control form-control-lg col-12"
                    placeholder="Nouveau Mot De Passe"
                    value={this.state.NouveauMotDePass}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({ NouveauMotDePass: e.target.value });
                        }
                    }
                    name="NouveauMotDePass"
                    type="password"
                />
                <input
                    className="form-control form-control-lg col-12"
                    placeholder="Confirmation Du Nouveau Mot De Passe"
                    value={this.state.ConfirmationMotDePass}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({ ConfirmationMotDePass: e.target.value });
                        }
                    }
                    name="ConfirmationMotDePass"
                    type="password"
                />
            </li>
        );
    }

    // affichage des informations du titulaire du compte.
    private DisplayInformation = () => {
        return (
            <div className="col-12">
                <ul className="list-group">
                    {this.DisplayModifMotDePasse()}
                </ul>
            </div>
        );
    }

    // Mise en ligne
    private sendServer = () => {
        return UserService.getInstance().changeUserPassword(this.props.userId, this.state.NouveauMotDePass);
    }

}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/ModifMdpProfileShow.tsx